var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckmarkinline = function SvgCheckmarkinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.38c-3.668 0-6.62 2.94-6.62 6.542 0 3.603 2.952 6.543 6.62 6.543s6.62-2.94 6.62-6.543C15.62 5.32 12.669 2.38 9 2.38ZM0 8.921C0 3.984 4.04 0 9 0s9 3.984 9 8.922c0 4.94-4.04 8.923-9 8.923S0 13.86 0 8.922Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13.353 5.618a1.19 1.19 0 0 1 .177 1.673l-4.806 5.948a1.19 1.19 0 0 1-1.762.098l-2.403-2.38a1.19 1.19 0 1 1 1.674-1.69L7.7 10.72l3.979-4.925a1.19 1.19 0 0 1 1.673-.177Z"
  })));
};

export default SvgCheckmarkinline;